export default import.meta.ROLLDOWN_FILE_URL_JJ8z0CQveRmkF1krM5eJtA